import { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import image from "../Images/bg.jpg";
import toast from 'react-hot-toast';
import HttpClient from '../utils/HttpClient';
import NumberCaptchaV2 from "../View/BusinessListing/components/NumberCaptchaV2";

const ResetPasswordNew = () => {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [verificationKey, setVerificationKey] = useState("");
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const params = useParams();
    const [errorMessage, setErrorMessage] = useState("");
    const [validation, setValidation] = useState({
        lowercase: false,
        uppercase: false,
        number: false,
        specialChar: false,
        minLength: false,
    });
    const [formError, setFormError] = useState({
        passwordError: "",
        confirmPasswordError: "",
        captchaError: "",
    });
    const captchaRef = useRef();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        setErrors({});
        setErrorMessage("");
        if (params?.key) {
            setVerificationKey(params?.key);
        } else {
            navigate("/");
        }
    }, [params]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});
        setErrorMessage("");
        if (!validateForm()) {
            console.log("Form validation failed.");
            return false;
        }

        const data = {
            password: password,
            confirmPassword: confirmPassword,
            verificationKey: verificationKey
        };
        const response = await HttpClient.requestData("reset-password", "POST", data);
        if (response && response?.status) {
            navigate("/user-login");
            toast.success("Your password reset successful!. You can login to your account with new password.");
        } else {
            setErrors(response?.error);
            setErrorMessage(response?.message);
        }
    }

    const validateForm = () => {
        let isValid = true;

        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>]).{8,16}$/;
        if (password.trim() === "") {
            setFormError((prevState) => ({
                ...prevState,
                passwordError: "Password is required.",
            }));
            isValid = false;
        } else if (!passwordRegex.test(password)) {
            setFormError((prevState) => ({
                ...prevState,
                passwordError: "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.",
            }));
            isValid = false;
        } else {
            setFormError((prevState) => ({ ...prevState, passwordError: "" }));
        }

        if (confirmPassword.trim() === "") {
            setFormError((prevState) => ({
                ...prevState,
                confirmPasswordError: "Password is required.",
            }));
            isValid = false;
        } else if (!passwordRegex.test(confirmPassword)) {
            setFormError((prevState) => ({
                ...prevState,
                confirmPasswordError: "Password must be 8-16 characters long, include at least one uppercase letter, one lowercase letter, one digit, and one special character.",
            }));
            isValid = false;
        } else {
            setFormError((prevState) => ({ ...prevState, confirmPasswordError: "" }));
        }

        const isNumCaptchValid = captchaRef.current.validate();
        if (!isNumCaptchValid) {
            setFormError((prevState) => ({
                ...prevState,
                captchaError: "Incorrect captcha answer.",
            }));
            isValid = false;
        } else {
            setFormError((prevState) => ({ ...prevState, captchaError: "" }));
        }
        return isValid;
    };

    return (
        <>
            <section className="authenSec">
                <div className="authenSecInn">
                    <div className="container">
                        <div className="authenSecInnDiv">
                            <div className="authenSecForm">
                                <div className="authenSecTop">
                                    <div className='forgetFig'>
                                    </div>
                                    <h4>Reset Password</h4>
                                </div>

                                <div className="authenSecBtm">
                                    <form onSubmit={handleSubmit}>
                                        <div className="form-group">
                                            <input
                                                type="password"
                                                placeholder='Password'
                                                value={password}
                                                onChange={(e) => setPassword(e.target.value)}
                                            />
                                            {errors?.password && (
                                                <span className="error">{errors?.password?.message}</span>
                                            )}
                                            {formError.passwordError && (
                                                <p className="error-message"
                                                    style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    {formError.passwordError}
                                                </p>
                                            )}
                                        </div>
                                        <div className="form-group">
                                            <input type="password" placeholder='confirm password'
                                                value={confirmPassword}
                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                            />
                                            {errors?.confirmPassword && (
                                                <span className="error">{errors?.confirmPassword?.message}</span>
                                            )}
                                            {errors?.verificationKey && (
                                                <span className="error">{errors?.verificationKey?.message}</span>
                                            )}
                                            {errorMessage && (
                                                <span className="error mt-2">{errorMessage}</span>
                                            )}
                                            {formError.confirmPasswordError && (
                                                <p className="error-message"
                                                    style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    {formError.confirmPasswordError}
                                                </p>
                                            )}
                                        </div>
                                        <div className='form-group'>
                                            <div className="addedasldibv">
                                                <NumberCaptchaV2 ref={captchaRef} />
                                            </div>

                                            {formError.captchaError && (
                                                <p
                                                    className="error-message"
                                                    style={{
                                                        color: "red",
                                                        fontSize: "12px",
                                                    }}
                                                >
                                                    {formError.captchaError}
                                                </p>
                                            )}
                                        </div>

                                        <button type='submit' to='/Memberownprofile' className='homeloginBtn'>Submit</button>
                                    </form>
                                </div>

                            </div>
                            <div className="authenSecImg">
                                <img src={image} alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default ResetPasswordNew